import { render } from "./post-smtp-notice.vue?vue&type=template&id=933438dc&scoped=true"
import script from "./post-smtp-notice.vue?vue&type=script&lang=js"
export * from "./post-smtp-notice.vue?vue&type=script&lang=js"

import "./post-smtp-notice.vue?vue&type=style&index=0&id=933438dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-933438dc"],['__file',"src/components/post-smtp-notice.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "933438dc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('933438dc', __exports__)) {
    api.reload('933438dc', __exports__)
  }
  
  module.hot.accept("./post-smtp-notice.vue?vue&type=template&id=933438dc&scoped=true", () => {
    api.rerender('933438dc', render)
  })

}


export default __exports__